import { BounceBar } from "@ui/Loaders";

const InputWithLabelSkeleton = () => (
  <div className="flex flex-col gap-1">
    <BounceBar className="h-4 w-24 rounded-2xl bg-gray-200 dark:bg-gray-600" />
    <BounceBar className="h-9 w-full rounded-xl bg-gray-200 dark:bg-gray-600" />
  </div>
);

export function CreateOrEditCompanySkeleton() {
  return (
    <div className="h-full flex flex-col">
      <div className="w-full h-6 bg-gray-200 dark:bg-gray-600" />
      {/* Title */}
      <BounceBar className="h-7 w-36 rounded-2xl bg-gray-200 dark:bg-gray-600 mt-2 mb-4 mx-4" />

      <div className="h-[calc(100vh_-_116px)] w-full flex flex-col overflow-y-auto gap-4">
        <div className="flex flex-col gap-4 px-4 flex-1">
          {/* Inputs & Selects */}
          <InputWithLabelSkeleton />
          <InputWithLabelSkeleton />

          {/* Themes */}
          <div className="flex flex-wrap py-2 gap-[4px_12px]">
            <BounceBar className="h-9 w-full rounded-xl bg-gray-200 dark:bg-gray-600" />
          </div>

          <InputWithLabelSkeleton />
          <InputWithLabelSkeleton />
          <InputWithLabelSkeleton />
          <InputWithLabelSkeleton />

          {/* Coverage Team */}
          <div className="flex flex-col gap-1.5 mb-2">
            <BounceBar className="h-4 w-28 rounded-2xl bg-gray-200 dark:bg-gray-600" />
            <BounceBar className="h-9 w-full rounded-xl bg-gray-200 dark:bg-gray-600" />
            <div className="flex flex-col gap-1">
              {[0, 1, 2].map((i) => (
                <div key={i} className="flex items-center gap-2 px-2 min-h-[36px]">
                  <BounceBar className="h-5 w-5 !rounded-full shrink-0 bg-gray-200 dark:bg-gray-600" />
                  <BounceBar className="h-4 w-24 rounded-2xl bg-gray-200 dark:bg-gray-600" />
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Buttons */}
        <div className="sticky bottom-0 flex flex-col gap-2 border-t-2 border-stroke-primary dark:border-gray-600 pt-4 px-4 bg-white dark:bg-gray-800">
          <BounceBar className="h-9 w-full rounded-xl bg-gray-200 dark:bg-gray-600" />
          <BounceBar className="h-9 w-full rounded-xl bg-gray-200 dark:bg-gray-600" />
        </div>
      </div>
    </div>
  );
}
